/* eslint-disable no-unused-vars */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Switch } from '../../components/ui/switch';
import {
  DollarSign, Edit2, Trash2, Save, Plus, RefreshCw, Download, Upload,
  ShoppingCart, MapPin, Building2, Briefcase, Tag, BarChart3, Settings,
  TrendingUp, TrendingDown, CheckCircle, XCircle, AlertTriangle, Eye,
  Globe, Filter, Search, Calculator, Percent, Euro, Target, Layers,
  FileSpreadsheet, FileJson, Copy, Archive, Clock, Users, Activity,
  Recycle, Loader2, Coins
} from 'lucide-react';
import axios from 'axios';
import TypesMaitresManager from '../../components/TypesMaitresManager';
import ReferentielsManager from '../../components/ReferentielsManager';
import { toast } from 'sonner';
import {
  TARIF_TYPES, TERRITOIRES, TYPES_ENTREPRISES, ACTIVITES_PROFESSIONNELLES,
} from '../GestionTarifsDemandesPubliques.constants';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const TarifsTab = ({ ctx }) => {
  const {
    activeTab, tarifs, tarifsParTerritoire, tarifsParType, tarifsParEntreprise,
    configParTypeBySpace, activeSpaceTarif, dirtyTypeBySpace, configParEntreprise,
    configParTerritoire, demandes, stats, loading, searchTerm, selectedTerritoire,
    selectedType, selectedStatut, tarifDialogOpen, editingTarif, statsDialogOpen,
    tarifForm, territoiresList, typesEntrepriseList, typesDemandeList, remisesPolitique,
    remisesPolitiqueLoading, viewDialogOpen, viewingDemande, demandeDialogOpen,
    editingDemande, demandeForm, programmees, programmeesLoading, tickNow,
    setActiveTab, setTarifs, setTarifsParTerritoire, setTarifsParType, setTarifsParEntreprise,
    setConfigParTypeBySpace, setActiveSpaceTarif, setDirtyTypeBySpace, setConfigParEntreprise,
    setConfigParTerritoire, setDemandes, setStats, setLoading, setSearchTerm, setSelectedTerritoire,
    setSelectedType, setSelectedStatut, setTarifDialogOpen, setEditingTarif, setStatsDialogOpen,
    setTarifForm, setTerritoiresList, setTypesEntrepriseList, setTypesDemandeList, setRemisesPolitique,
    setRemisesPolitiqueLoading, setViewDialogOpen, setViewingDemande, setDemandeDialogOpen,
    setEditingDemande, setDemandeForm, setProgrammees, setProgrammeesLoading, setTickNow,
    fetchAllData, fetchConfigTerritoires, fetchConfigTypesAllSpaces, fetchDemandes, fetchProgrammees,
    fetchStats, fetchTarifs, filteredDemandes, formatCountdown, getTerritoireInfo, getTypeInfo,
    handleAdminDeleteDemande, handleAdminDuplicateDemande, handleAdminEditDemande, handleCancelSchedule,
    handleCloneFromDefault, handleDeleteTarif, handleDuplicateTarif, handleExport, handlePublishNow,
    handleSaveAdminDemande, handleSaveAllConfigTypeSpace, handleSaveConfigEntreprise,
    handleSaveConfigTerritoire, handleSaveConfigType, handleSaveTarif, handleToggleTarif, handleViewDemande,
    loadReferentielsFromApi, loadRemisesPolitique, openEditDialog, parseActivitesFromDemande,
    resetTarifForm, saveRemisesPolitique, toggleActivite, updateConfigEntreprise, updateConfigTerritoire,
    updateConfigType, SPACES_TARIF, getAuthHeader, emptyTypeConfig,
  } = ctx;
  return (
        <TabsContent value="tarifs" className="mt-4">
          <Card className="border-0 shadow-lg">
            <CardHeader className="flex flex-row items-center justify-between">
              <div>
                <CardTitle className="flex items-center gap-2">
                  <DollarSign className="h-5 w-5 text-emerald-600" />
                  Tarifs de base
                </CardTitle>
                <CardDescription>Définissez les prix de base pour chaque type de lead</CardDescription>
              </div>
              <div className="flex gap-2">
                <Button variant="outline" size="sm" onClick={() => handleExport('csv')}>
                  <Download className="h-4 w-4 mr-1" /> Exporter
                </Button>
                <Button onClick={() => { resetTarifForm(); setTarifDialogOpen(true); }} className="bg-emerald-600 hover:bg-emerald-700">
                  <Plus className="h-4 w-4 mr-1" /> Nouveau tarif
                </Button>
              </div>
            </CardHeader>
            <CardContent>
              <div className="grid gap-4">
                {tarifs.map(tarif => {
                  const typeInfo = getTypeInfo(tarif.type_demande);
                  return (
                    <div 
                      key={tarif.id}
                      className={`p-4 rounded-xl border ${tarif.is_active ? 'bg-white border-slate-200' : 'bg-slate-50 border-slate-100 opacity-60'}`}
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                          <div className={`p-3 rounded-xl ${
                              typeInfo.color === 'green' ? 'bg-green-700' :
                              typeInfo.color === 'blue' ? 'bg-blue-700' :
                              typeInfo.color === 'purple' ? 'bg-purple-700' :
                              typeInfo.color === 'orange' ? 'bg-orange-600' :
                              typeInfo.color === 'red' ? 'bg-red-700' :
                              'bg-slate-700'
                            }`}>
                            <span className="text-2xl">{typeInfo.icon}</span>
                          </div>
                          <div>
                            <div className="flex items-center gap-2">
                              <span className="font-bold text-lg text-slate-800">{tarif.nom}</span>
                              <Badge className="font-mono text-xs bg-slate-700 text-white border-slate-700 font-semibold">{tarif.code}</Badge>
                              <Badge className={
                                typeInfo.color === 'green' ? 'bg-green-700 text-white' :
                                typeInfo.color === 'blue' ? 'bg-blue-700 text-white' :
                                typeInfo.color === 'purple' ? 'bg-purple-700 text-white' :
                                typeInfo.color === 'orange' ? 'bg-orange-600 text-white' :
                                'bg-slate-700 text-white'
                              }>
                                {typeInfo.label}
                              </Badge>
                            </div>
                            <p className="text-sm text-slate-500 mt-1">{tarif.description || 'Tarif standard'}</p>
                          </div>
                        </div>
                        
                        <div className="flex items-center gap-4 md:gap-6">
                          <div className="text-center">
                            <div className="text-2xl font-bold text-emerald-600">{tarif.prix_base}€</div>
                            <div className="text-xs text-slate-500">Prix CB</div>
                          </div>
                          <div className="text-center">
                            <div className="text-2xl font-bold text-purple-600">{tarif.prix_credits}</div>
                            <div className="text-xs text-slate-500">Crédits</div>
                          </div>
                          <div className="flex items-center gap-1">
                            <Button variant="ghost" size="sm" onClick={() => openEditDialog(tarif)} title="Modifier" data-testid={`tarif-edit-${tarif.code}`}>
                              <Edit2 className="h-4 w-4" />
                            </Button>
                            <Button
                              variant="ghost"
                              size="sm"
                              className="text-blue-600"
                              onClick={() => handleDuplicateTarif(tarif)}
                              title="Dupliquer ce tarif"
                              data-testid={`tarif-duplicate-${tarif.code}`}
                            >
                              <Copy className="h-4 w-4" />
                            </Button>
                            <Button 
                              variant="ghost" 
                              size="sm"
                              className={tarif.is_active ? 'text-orange-600' : 'text-green-600'}
                              onClick={() => handleToggleTarif(tarif)}
                              title={tarif.is_active ? 'Désactiver' : 'Activer'}
                            >
                              {tarif.is_active ? <XCircle className="h-4 w-4" /> : <CheckCircle className="h-4 w-4" />}
                            </Button>
                            <Button variant="ghost" size="sm" className="text-red-600" onClick={() => handleDeleteTarif(tarif.id)} title="Supprimer">
                              <Trash2 className="h-4 w-4" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </CardContent>
          </Card>
        </TabsContent>
  );
};

export default TarifsTab;
